import { StylingModel } from '../style/styling.model';
import { CoreStylingModel } from '../core/core-styling.model';
import { TreeviewStylingModel } from '../treeview/treeview-styling.model';
export class JsonEditorStylingModel extends CoreStylingModel {
/**
 * Styling of header section by StylingModel
 */
header?: StylingModel;
/**
 * Styling of Treeview by TreeviewStylingModel
 */
treeview?: TreeviewStylingModel;
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function JsonEditorStylingModel_tsickle_Closure_declarations() {
/**
 * Styling of header section by StylingModel
 * @type {?}
 */
JsonEditorStylingModel.prototype.header;
/**
 * Styling of Treeview by TreeviewStylingModel
 * @type {?}
 */
JsonEditorStylingModel.prototype.treeview;
}

